module.exports = __webpack_public_path__ + "static/2315ae6c.Order.png";